import type { ChannelWorkingHoursEntity } from '../entities/ChannelWorkingHoursEntity'
import type { ChannelAvailabilityStatus } from '@/backend/market'

export abstract class ChannelWorkingHoursRepository {
  abstract get(channelId: number, regionId: number): Promise<ChannelWorkingHoursEntity | { error: true }>
  abstract updateShifts(
    channelId: number,
    regionId: number,
    data: ChannelWorkingHoursEntity
  ): Promise<{ success: true } | { error: true }>
  abstract updateStatus(
    channelId: number,
    regionId: number,
    status: ChannelAvailabilityStatus,
    expiresAt: string | null
  ): Promise<{ success: true } | { error: true }>
}
